import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!localStorage.getItem("ep_token")) return setUser(false);
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const signIn = ({ token, user: u }) => {
    localStorage.setItem("ep_token", token);
    setUser(u);
  };
  const signOut = () => {
    localStorage.removeItem("ep_token");
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, setUser, signIn, signOut }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
